import * as React from 'react'

export const isWitik = (n) => /witik/i.test(n)

export const ComparisonLogo = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='148'
      height='40'
      fill='none'
      viewBox='0 0 148 40'
      className='mx-auto max-w-[80%]'
    >
      <g fill='#fff' clipPath='url(#ComparisonLinkLogo)'>
        <path d='m79.16 10-2.81 13.9h-.76l-.04-.16L71.97 10H66.4l-3.57 13.9h-.72L59.2 10h-5.96l5.07 20.1h7.62l2.82-10.44h.7l.05.17 2.8 10.28h7.58L85.01 10h-5.85Zm15.64 0h-6.1v20.1h6.1V10Zm17.94 0H98.5v4.59h3.7V30.1h6.1V14.59h4.43V10Zm9.85 0h-6.1v20.1h6.1V10Zm18.08 20.1h6.66l-6.9-10.54.1-.12L147.2 10h-6.37l-5.31 7.78h-1.55V10h-6.03v20.1h6.03v-7.7h1.55l5.15 7.7Z' />
        <path
          fillRule='evenodd'
          d='M20.67 40a20 20 0 1 0 0-40 20 20 0 0 0 0 40Zm3.6-17.5 4.95-10.83h4.26l-7.33 16.06H22.4l-1.56-3.4 2.13-4.66 1.29 2.83Zm-.94-10.83L16 27.74h-3.74l-4.93-10.8h4.27l2.54 5.56 4.95-10.83h4.24Z'
          clipRule='evenodd'
        />
      </g>
      <defs>
        <clipPath id='ComparisonLinkLogo'>
          <path fill='#fff' d='M.67 0h146.67v40H.67z' />
        </clipPath>
      </defs>
    </svg>
  )
}
